/* eslint-disable @nx/enforce-module-boundaries */
import { AdddCircleIcon } from '@mybridge/icons';
import { Tag, TagCloseButton, TagLabel, Button } from '@mybridge/ui';
import { useDisclosure } from '@mybridge/ui/hooks';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { HStack } from '@mybridge/ui/layout';
import { List, ListItem } from '@mybridge/ui/list';
import { CirclePlus } from '@mybridge/icons';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { Spinner } from '@mybridge/ui/spinner';
import { Text } from '@mybridge/ui/text';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useJobTitles } from 'v4/lib/hooks/use-job-titles';
import { CustomDropdown } from '../custom-dropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const JobTitlesDropdown = ({ ...props }) => {
  const [search, setSearch] = useState();

  const { data, createLoading, mutateAsync, isLoading, refetch } = useJobTitles({
    search,
  });

  const jobtitles = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  useEffect(() => {
    refetch?.();
  }, [])



  return (
    <CustomDropdown
      {...props}
      data={jobtitles}
      isLoading={isLoading}
      onSearch={(s) => setSearch(s)}
    />
  );
};

export const JobTitlesTaggedInput = ({
  value,
  defaultValue,
  onChange,
  keyName = 'name',
  round = true,
  ...props
}) => {
  const [selected, setSelected] = useState(defaultValue ?? []);
  const [mode, setMode] = useState();
  const { t } = useTranslator();
  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(selected)) {
      setSelected(value);
    }
  }, [value]);

  const handleChange = (val) => {
    if (!selected?.includes(val?.title)) {
      selected?.push(val?.title);
      onChange_([...(selected ?? [])]);
      setMode(null);
    }
  };

  const handleRemove = (val) => (e) => {
    const sel = selected?.filter?.((s) => s !== val);
    onChange_([...(sel ?? [])]);
  };

  const onChange_ = (val) => {
    setSelected(val);
    onChange?.(val);
  };

  return (
    <div flexWrap="wrap">
      <HStack mt={2}>
        {selected?.length ? (
          <>
            {selected?.map((s, sIndex) => (
              <Tag
                border="1px solid"
                borderColor="gray.300"
                fontSize="sm"
                bgColor="brandGray.200"
                p="5px 12px"
                borderRadius={round ? 'full' : '5'}
                key={sIndex}
              >
                <TagLabel pl={2}>{s}</TagLabel>
                <TagCloseButton color="brandPrimary.500" onClick={handleRemove(s)} px={3} />
              </Tag>
            ))}
          </>
        ) : null}
        {mode === 'add' ? (
          <JobTitlesDropdown
            inputGroupProps={{
              maxW: '200px',
            }}
            autoFocus
            borderRadius={round ? 'full' : '5'}
            maxW="200px"
            onChange={handleChange}
            existing={selected}
          />
        ) : (
          ''
        )}

        {!mode ? (
          <Button
            border="1px solid"
            borderColor="gray.300"
            fontSize="sm"
            bgColor="brandGray.200"
            onClick={(e) => setMode('add')}
            h="32px"
            p="5px 12px"
            borderRadius={round ? 'full' : '5'}
            rightIcon={<CirclePlus width={20} height={20} />}
          >
            {t('otherModules.add_job_title') || "Add Job Title"}
          </Button>
        ) : (
          ''
        )}
      </HStack>
    </div>
  );
};
